var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneoIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.97345C0 7.42157 0 7.14563 0.0740273 6.89151C0.139601 6.66641 0.247366 6.4547 0.392027 6.26677C0.555337 6.05461 0.782021 5.8852 1.23539 5.54638L8.0177 0.477696C8.36902 0.215138 8.54468 0.0838583 8.73865 0.0333949C8.9098 -0.0111316 9.0902 -0.0111316 9.26135 0.0333949C9.45532 0.0838583 9.63098 0.215138 9.98231 0.477697L16.7646 5.54638C17.218 5.8852 17.4447 6.05461 17.608 6.26677C17.7526 6.4547 17.8604 6.66641 17.926 6.89151C18 7.14563 18 7.42157 18 7.97345V14.9252C18 16.0015 18 16.5396 17.782 16.9507C17.5903 17.3123 17.2843 17.6063 16.908 17.7905C16.4802 18 15.9201 18 14.8 18H3.2C2.0799 18 1.51984 18 1.09202 17.7905C0.715695 17.6063 0.409734 17.3123 0.217987 16.9507C0 16.5396 0 16.0015 0 14.9252V7.97345Z",
    fill: "#DCEFE1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2753_65583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6058 9.04736L10.3386 10.2378V4.94336H7.69865V10.2378L6.43145 9.04736L4.62305 10.971L9.01865 15.1014L13.4142 10.971L11.607 9.04736H11.6058ZM4.96265 10.9614L6.44225 9.38696L7.93865 10.7934V5.18336H10.0986V10.7934L11.595 9.38696L13.0746 10.9614L9.01865 14.7726L4.96265 10.9614Z",
    fill: "#004C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5859 9.72703L9.85913 11.3482V5.42383H8.17913V11.3482L6.45233 9.72703L5.30273 10.951L9.01913 14.443L12.7355 10.951L11.5859 9.72703Z",
    fill: "#004C3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2753_65583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(3 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneoIn);
export default __webpack_public_path__ + "static/media/OneoIn.a7cd2e179dd3cbf7fc7d458c179d242a.svg";
export { ForwardRef as ReactComponent };